module.exports = __webpack_public_path__ + "img/bank-account-switch-disabled.6a99a20a.svg";